export const documentBusUrls = {
  updateSaleOrder: '/UpdateSaleOrderWebStatus',
  notifyCreateRequest: '/NotifyCreateRequestDispatch',
  searchSaleOrderId: '/SearchBySaleOrderId?OrderSaleId=',
  searchIntegrationDocuments: '/SearchIntegrationDocuments',
  listBranchOffices: '/BranchOffices/',
  detailDocument: '/IntegrationInvoiceDetail/',
}
